/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The platform of the meeting
 */
export type GetBotDetailsResponseDataMeetingPlatform =
  (typeof GetBotDetailsResponseDataMeetingPlatform)[keyof typeof GetBotDetailsResponseDataMeetingPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBotDetailsResponseDataMeetingPlatform = {
  zoom: "zoom",
  meet: "meet",
  teams: "teams"
} as const
